import React from 'react';
import StaffProfileTemplate, {
  ProfileSection,
  ProfileParagraphs,
  ProfileBullets,
  ProfilePublications,
  ProfileContactSection,
} from './StaffProfileTemplate';

const JyotiPatilProfile = () => {
  const person = {
    id: 'jyoti-patil',
    name: 'Jyoti Patil',
    honorific: 'Ms',
    title: 'Highland Fellow',
    affiliation: 'Executive Director (Chief Secretary), Aaorhi, Uttarakhand',
    image: 'https://customer-assets-0z36b82j.emergentagent.net/job_7a4f11f8-6c06-4e1c-b433-73d9453c195e/artifacts/qv1kfttw_Jyoti.webp',
    email: 'jyosheen1@gmail.com',
    category: 'Fellows & Visiting Scholars',
    testid: 'jyoti-patil-profile',
  };

  return (
    <StaffProfileTemplate person={person}>
      {/* Intellectual Biography */}
      <ProfileSection title="Intellectual Biography">
        <ProfileParagraphs
          items={[
            'Jyoti Patil has extensive experience in development communication, combining a strong theoretical foundation from her education in development studies and mass communication with practical fieldwork across India. She is skilled in designing communication strategies, experimenting with participatory methods, and producing information and resource materials for development organizations.',
            'She is proficient in evaluative documentation, documentary filmmaking, and ethnographic photography. Her strength lies in analyzing life stories as a research methodology, and she is passionate about storytelling and creative writing. She is adept at integrating new and traditional communication tools to reach diverse audiences.',
            'Jyoti was awarded the NUFFIC fellowship for an M.A. in Development Studies at the Institute of Social Studies, The Hague, Netherlands. She also holds a Diploma in Permaculture Design from Oregon State University and is a certified permaculture designer and practitioner. She is currently learning herbal medicine and building practical knowledge of Himalayan agrarian life.',
            'Her move to the mountains was inspired by a humbling year spent living with Tibetan shepherds in the Changtang region of Ladakh as part of a research study. This experience led her to leave city life to live and work close to the land in the Kumaon region of Uttarakhand.',
          ]}
        />
      </ProfileSection>

      {/* Research Foci & Areas of Work */}
      <ProfileSection title="Research Foci & Areas of Work">
        <ProfileBullets
          items={[
            'Participatory communication and Communication for Development',
            'Evaluative documentation and ethnographic photography',
            'Documentary filmmaking',
            'Life histories and life stories as research methodology',
            'Livelihood strategies and rural livelihoods',
            'Agrarian crisis and pressures facing farmers under a changing climate',
            'Natural resource management and agriculture',
            'Sustainable mountain development',
            'Permaculture design and practice',
          ]}
        />
      </ProfileSection>

      {/* Highland Institute Projects */}
      <ProfileSection title="Highland Institute Projects">
        <ProfileParagraphs
          items={[
            'Jyoti brings her expertise in participatory communication, documentary filmmaking, and sustainable mountain development to collaborative research initiatives at The Highland Institute. Her background in ethnographic documentation and life history research complements the Institute\'s focus on Indigenous knowledge systems and community-engaged scholarship in Highland Asia.',
          ]}
        />
      </ProfileSection>

      {/* Selected Projects & Initiatives */}
      <ProfileSection title="Selected Projects & Initiatives">
        <ProfileParagraphs
          items={[
            <>As Executive Director of Aaorhi, she has spearheaded integrated development programs in the Kumaon region of Uttarakhand (covering the central and greater Himalayas), including initiatives in maternal and child health care, education, natural resource management, and rural livelihoods.</>,
            'She has designed and implemented food forests for wildlife to reduce crop foraging by wild animals, and contributed to initiatives on seed sovereignty and on women\'s and youth participation in conservation and natural resource management in Maharashtra and Chhattisgarh.',
            'She participated in piloting community farming models in Vidarbha and designed the School Farm Project in Uttarakhand, contextualizing education within farming and ecology.',
            <>Her feature film script, <em>Yasodhara - Ek Kaavya</em>, is currently under production by the National Film Development Corporation. She has made numerous documentaries on rural livelihoods, domestic violence, de-notified communities, women's empowerment, and the environment.</>,
          ]}
        />
      </ProfileSection>

      {/* Education */}
      <ProfileSection title="Education">
        <ProfileBullets
          items={[
            'M.A. Development Studies (Rural Livelihoods and Global Change), Institute of Social Studies, The Hague, Netherlands (2008) — NUFFIC Fellowship',
            'Master\'s Programme in Mass Communication (Broadcast Journalism and Video Production), Pune, Maharashtra, India (2002)',
            'Diploma in Permaculture Design, Oregon State University — Certified Permaculture Designer and Practitioner',
          ]}
        />
      </ProfileSection>

      {/* Contact & Scholarly Infrastructure */}
      <ProfileContactSection
        email={person.email}
        role="Highland Fellow; Executive Director (Chief Secretary), Aaorhi"
        affiliationLines={[
          'Aaorhi',
          'Village Chatola, Post Mukteshwar',
          'Dist. Nainital, Uttarakhand – 263138',
          'India'
        ]}
        testidPrefix="jyoti"
        scholarlyProfiles={[
          { label: 'YouTube Channel', url: 'https://www.youtube.com/@jyosheen', testid: 'jyoti-youtube-link' },
        ]}
      />
    </StaffProfileTemplate>
  );
};

export default JyotiPatilProfile;
